'use client'

import { useEffect } from 'react'
import { useRouter, useSearchParams } from 'next/navigation'
import dynamic from 'next/dynamic'
import { LandingHero, FooterHero } from '@/components/landing/hero'
import { ConnectSection } from '@/components/landing/connect-section'
import Script from 'next/script'
import PreviewCardSection from '@/components/landing/preview-card-section'
import { LogoVelocity } from '@/components/landing/logo-velocity'

// Dynamically import below-fold sections for better performance
// const FeatureCardSection = dynamic(
//     () =>
//         import('@/components/landing/feature-card-section').then((mod) => ({
//             default: mod.FeatureCardSection,
//         })),
//     {
//         loading: () => <div className="min-h-[400px]" />,
//     }
// )

const IconFeatureCardSection = dynamic(
    () =>
        import('@/components/landing/icon-feature-card-section').then((mod) => ({
            default: mod.IconFeatureCardSection,
        })),
    {
        loading: () => <div className="min-h-[300px]" />,
    }
)

const PartnershipSection = dynamic(
    () =>
        import('@/components/landing/partnership-section').then((mod) => ({
            default: mod.PartnershipSection,
        })),
    {
        loading: () => <div className="min-h-[200px]" />,
    }
)

const HeroCalloutSection = dynamic(
    () =>
        import('@/components/landing/hero-callout-section').then((mod) => ({
            default: mod.HeroCalloutSection,
        })),
    {
        loading: () => <div className="min-h-[300px]" />,
    }
)
// import { LogoVelocity } from '@/components/landing/logo-velocity'

export function HomePageClient() {
    const router = useRouter()
    const searchParams = useSearchParams()

    // Handle OAuth callback code if it lands on home page
    useEffect(() => {
        const code = searchParams.get('code')
        if (code) {
            // OAuth code detected on home page - redirect to proper callback handler
            const next = searchParams.get('next') || '/dashboard'
            const callbackUrl = `/auth/callback?code=${code}&next=${encodeURIComponent(next)}`
            router.replace(callbackUrl)
        }
    }, [searchParams, router])

    // Authenticated user redirect is handled by middleware (server-side)
    // This prevents the landing page flash issue

    // SoftwareApplication structured data for homepage
    const structuredData = {
        '@context': 'https://schema.org',
        '@type': 'SoftwareApplication',
        name: 'Insighthread',
        applicationCategory: 'FinanceApplication',
        operatingSystem: 'Web',
        offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'USD',
        },
        aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '4.8',
            ratingCount: '1250',
        },
        description:
            'Research stocks without switching tabs. AI-powered stock market analysis platform with real-time insights, forecasts, and comprehensive financial data.',
        featureList: [
            'AI-Powered Stock Analysis',
            'Real-Time Market Insights',
            'Revenue Breakdown',
            'Financial Statements',
            'Insider Trades & Holdings',
            'Institutional Trades & Holdings',
            'Stock Forecasting',
            'Calendar & Events',
        ],
    }

    // Always render landing page immediately - redirect happens in background
    return (
        <div>
            <Script
                id="homepage-structured-data"
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
            />
            <LandingHero />
            <PreviewCardSection />
            <LogoVelocity />
            {/* <SplitContentSection /> */}
            <IconFeatureCardSection />
            {/* <FeatureCardSection /> */}
            <PartnershipSection />
            <HeroCalloutSection />
            <ConnectSection />
            <FooterHero />
        </div>
    )
}
